"use client";

import { XCircle } from "lucide-react";

/**
 * Modular FULL Badge Component
 * Displays a professional, eye-catching badge indicating service is full/unavailable
 * 
 * @param {Object} props
 * @param {string} props.position - Position of badge: 'top-left' | 'top-right' | 'bottom-center' (default: 'top-right')
 * @param {string} props.className - Additional CSS classes
 */
export default function FullBadge({ position = "top-right", className = "" }) {
  const positionClasses = {
    "top-left": "absolute top-1 left-1",
    "top-right": "absolute top-1 right-1",
    "bottom-center": "absolute bottom-1 left-1/2 -translate-x-1/2",
  };

  return (
    <div className={`${positionClasses[position]} z-20 ${className}`}>
      <div className="relative">
        {/* Main badge with reduced padding */}
        <div className="relative bg-gradient-to-r from-red-600 via-red-700 to-red-800 text-white text-[9px] font-extrabold px-1.5 py-0.5 rounded-[8px]">
          <span className="relative z-10 flex items-center gap-1">
            <XCircle className="w-2.5 h-2.5" />
            <span className="tracking-tight">FULL</span>
          </span>
        </div>
      </div>
    </div>
  );
}

